module.exports = __webpack_public_path__ + "static/media/antoine-barres.dfbf459c.jpg";